module.exports = __webpack_public_path__ + "img/icon_card_suspend.1da28669.png";